import styled, { css } from 'styled-components';
import { mobile_xl, tablet_s } from '../../../global/mediaQueryMixin';
interface Props {
  isOpen?: boolean;
  isResponsiveMaxWidth?: boolean;
  overflow?: 'auto' | 'visible' | 'hidden' | ' scroll';
  maxWidth?: string;
}

const ModalOverlay = styled.div<Props>`
  display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
  position: fixed;
  inset: 0;
  background-color: var(--background-overlay);
  backdrop-filter: blur(1px);
  align-items: center;
  justify-content: center;
  z-index: var(--z-index-999);
  ${mobile_xl(css`
    background: var(--modal-background-overlay);
    backdrop-filter: blur(20px);
    z-index: var(--z-index-toast);
  `)}
`;

const ModalContent = styled.div<Props>`
  background-color: var(--background-primary);
  border-radius: var(--border-radius-16);
  box-shadow: var(--modal-shadow);
  max-width: ${({ maxWidth }) => maxWidth};
  width: 100%;
  max-height: 90dvh;
  overflow: ${({ overflow }) => (overflow ? overflow : 'auto')};
  z-index: var(--z-index-999);
  ${({ isResponsiveMaxWidth }) =>
    isResponsiveMaxWidth &&
    css`
      ${tablet_s(css`
        max-width: calc(100% - 80px);
      `)}
    `}
  ${mobile_xl(css`
    z-index: var(--z-index-toast);
    max-height: 95dvh;
    max-width: calc(100% - 40px);
    width: 100%;
  `)}
`;

export { ModalOverlay, ModalContent };
